/* ============================================================
   BENZOBAK — поведение темы

   Без фреймворков и без зависимостей: на странице товара и так
   тяжёлые изображения, тянуть ради пяти обработчиков ещё сотню
   килобайт незачем. Всё вешается делегированием на document,
   поэтому работает и после перерисовки секций в редакторе темы.
   ============================================================ */
(() => {
  'use strict';

  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];

  /* ── Цели аналитики ──────────────────────────────────────
     Оформления заказа на сайте нет, поэтому считать нечего, кроме обращений:
     отправленная заявка, нажатие на WhatsApp и нажатие на телефон. Эти три
     цели и заводятся в Метрике под теми же именами.

     Молчим, если счётчик не подключён: window.fzMetrikaId ставит сниппет
     fz-metrika.liquid, и без номера в настройках темы его просто нет. */
  function цель(имя) {
    if (typeof window.ym === 'function' && window.fzMetrikaId) {
      window.ym(window.fzMetrikaId, 'reachGoal', имя);
    }
  }

  /* Делегированием на document: кнопка WhatsApp живёт и в шапке, и на карточке
     товара, и в корзине, а телефон ещё и в подвале. */
  function initGoals() {
    if (document.documentElement.dataset.wiredGoals) return;
    document.documentElement.dataset.wiredGoals = 'true';
    document.addEventListener('click', (event) => {
      const ссылка = event.target.closest('a[href]');
      if (!ссылка) return;
      const адрес = ссылка.getAttribute('href');
      if (этоWhatsApp(адрес)) цель('whatsapp');
      else if (адрес.startsWith('tel:')) цель('phone');
    });
  }

  function этоWhatsApp(адрес) {
    return адрес.includes('wa.me/') || адрес.includes('api.whatsapp.com');
  }

  /* ── WhatsApp без вопроса Shopify «уходите из магазина?» ──
     С 21.10.2026 Shopify перед каждой ссылкой на чужой сайт спрашивает
     «Are you sure you want to leave BENZOBAK?» (shopify.exit_interstitial, отключить
     нельзя; instagram.com у него в исключениях, wa.me нет). Владелец: «так не пойдет».
     На телефоне WhatsApp открывается ссылкой whatsapp://, это не сайт, и вопроса нет;
     текст сообщения тот же. Скрипт Shopify не трогает нажатие, которое страница уже
     обработала, поэтому берём нажатие сами. Если на Android приложения нет и страница
     через пару секунд всё ещё на экране — обычная ссылка wa.me. На iPhone система сама
     спрашивает «Открыть в WhatsApp?», запасной переход там не нужен.
     Компьютер (владелец: «на компе нужно решить»): нажатие открывает wa.me в новой вкладке
     нашим обработчиком (window.open), как это сделала бы ссылка. Вопрос Shopify ловит нажатия
     на ссылки и переходы этого окна, а не новую вкладку, открытую страницей. Если Shopify
     однажды закроет и это, вернётся вопрос, ничего не сломается.
     То же в теме нового дизайна (theme-v2/assets/bb-site.js). Цель «whatsapp» считает
     обработчик initGoals выше, он срабатывает после этого. */
  const наIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));
  const наТелефоне = наIOS || /Android/i.test(navigator.userAgent);
  function ссылкаВПриложение(адрес) {
    let url;
    try { url = new URL(адрес, location.href); } catch { return ''; }
    let номер = '';
    if (/(^|\.)wa\.me$/i.test(url.hostname)) номер = url.pathname.replace(/\D/g, '');
    else if (/(^|\.)whatsapp\.com$/i.test(url.hostname)) номер = (url.searchParams.get('phone') || '').replace(/\D/g, '');
    if (!номер) return '';
    const текст = url.searchParams.get('text');
    return `whatsapp://send?phone=${номер}${текст ? `&text=${encodeURIComponent(текст)}` : ''}`;
  }
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const ссылка = event.target.closest && event.target.closest('a[href]');
    if (!ссылка) return;
    const сайт = ссылка.href;
    const приложение = ссылкаВПриложение(сайт);
    if (!приложение) return;
    event.preventDefault();
    if (!наТелефоне) { window.open(сайт, '_blank', 'noopener'); return; }
    let ушли = false;
    const ушёл = () => { ушли = true; };
    window.addEventListener('pagehide', ушёл, { once: true });
    window.addEventListener('blur', ушёл, { once: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) ушёл(); }, { once: true });
    window.location.href = приложение;
    if (!наIOS) setTimeout(() => { if (!ушли && !document.hidden) window.location.href = сайт; }, 2500);
  }, true);

  /* ── Фасад видео ─────────────────────────────────────────
     iframe подставляется только по клику: три ролика на карточке
     LC300 иначе тянут около мегабайта скриптов ещё до прокрутки. */
  function openVideo(button) {
    const id = button.dataset.fzVideo;
    if (!id) return;
    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    frame.title = button.getAttribute('aria-label') || 'Видео';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    button.replaceChildren(frame);
    button.classList.add('is-playing');
  }

  /* ── Фоновое видео героя ─────────────────────────────────
     Источник подставляется вручную, элемент проявляется по loadeddata:
     пустой <video> до первого кадра рисует чёрный прямоугольник поверх
     постера. При отключённом движении видео не грузится вовсе. */
  function initHeroVideo() {
    const video = $('[data-fz-hero-video]');
    if (!video || reduceMotion || !video.dataset.src) return;
    video.addEventListener('loadeddata', () => { video.dataset.ready = 'true'; }, { once: true });
    video.src = video.dataset.src;
    video.play().catch(() => {
      /* Автовоспроизведение может быть запрещено политикой браузера —
         тогда просто остаётся постер, и это допустимый исход. */
    });
  }

  /* ── Прокрутка под окном ───────────────────────────────
     Пока открыто окно, страница под ним стоять должна: иначе палец или колесо
     уводят фон, и по закрытии человек оказывается не там, где был. Ширину полосы
     прокрутки возвращаем отступом, иначе страница дёргается вбок на пиксели. */
  let замков = 0;
  function заперетьПрокрутку() {
    if (замков++) return;
    const полоса = innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    if (полоса > 0) document.documentElement.style.paddingRight = `${полоса}px`;
  }
  function отпуститьПрокрутку() {
    if (замков === 0 || --замков) return;
    document.documentElement.style.overflow = '';
    document.documentElement.style.paddingRight = '';
  }

  /* ── Телефон ───────────────────────────────────────────
     Номер набирается сплошной строкой, и в письме менеджеру приходит
     «77777777777». Приводим к виду из подсказки прямо при вводе.

     Каретку держим по числу цифр слева от неё, а не по числу символов:
     форматирование вставляет скобки и пробелы, и позиция в символах уезжает,
     стоит поправить номер в середине. */
  function форматТелефона(цифры) {
    let d = цифры.replace(/\D/g, '');
    if (d.startsWith('8')) d = `7${d.slice(1)}`;
    if (!d.startsWith('7')) d = `7${d}`;
    d = d.slice(0, 11);
    const части = ['+7'];
    if (d.length > 1) части.push(` (${d.slice(1, 4)}`);
    if (d.length >= 4) части.push(')');
    if (d.length > 4) части.push(` ${d.slice(4, 7)}`);
    if (d.length > 7) части.push(` ${d.slice(7, 9)}`);
    if (d.length > 9) части.push(` ${d.slice(9, 11)}`);
    return части.join('');
  }

  function initPhone() {
    for (const поле of $$('[data-fz-phone]')) {
      if (поле.dataset.wired) continue;
      поле.dataset.wired = 'true';
      поле.addEventListener('input', () => {
        const было = поле.value;
        const цифрДоКаретки = было.slice(0, поле.selectionStart ?? было.length).replace(/\D/g, '').length;
        поле.value = форматТелефона(было);
        // Ставим каретку после той же по счёту цифры.
        let место = поле.value.length;
        let счёт = 0;
        for (let n = 0; n < поле.value.length; n++) {
          if (/\d/.test(поле.value[n])) счёт++;
          if (счёт === цифрДоКаретки + (было.startsWith('8') || было.startsWith('7') ? 0 : 1)) {
            место = n + 1;
            break;
          }
        }
        поле.setSelectionRange(место, место);
      });
      // Пустое поле не трогаем: подсказка в нём полезнее, чем одинокий «+7».
      поле.addEventListener('blur', () => {
        if (поле.value.replace(/\D/g, '').length <= 1) поле.value = '';
      });
    }
  }

  /* ── Заявка без почты ──────────────────────────────────
     Shopify отклоняет форму с пустым `contact[email]`: отвечает «Электронный
     адрес недействителен». Телефон у нас обязательный, почта нет, и человек
     без почты упирался в ошибку на ровном месте.

     Подставляем адрес из его же номера на несуществующий поддомен. Форма
     проходит, а менеджер по строке «77071234567@no-email…» сразу видит, что
     писать некуда и звонить надо по телефону. */
  function initCallbackEmail() {
    const почта = $('[data-fz-email]');
    const форма = почта?.form;
    if (!почта || !форма || форма.dataset.wiredEmail) return;
    форма.dataset.wiredEmail = 'true';
    форма.addEventListener('submit', () => {
      if (почта.value.trim()) return;
      const цифры = ($('[data-fz-phone]', форма)?.value ?? '').replace(/\D/g, '');
      const домен = почта.dataset.fzNoMailDomain || 'no-email.invalid';
      почта.value = `${цифры || 'zayavka'}@${домен}`;
    });
  }

  /* ── Окно после отправки заявки ──────────────────────────
     Shopify оставляет в адресе `?contact_posted=true`, и без чистки адреса
     окно всплывало бы при каждой перезагрузке и при возврате назад. */
  function initModal() {
    const modal = $('[data-fz-modal]');
    if (!modal || modal.dataset.wired) return;
    modal.dataset.wired = 'true';

    // Окно рисуется Liquid только после успешной отправки формы, поэтому
    // сюда мы попадаем ровно один раз на заявку. Отдельного обработчика
    // submit не нужно: он сработал бы и на неудачной отправке.
    цель('zayavka');

    // Убираем и метку об отправке, и якорь #contact_form: по якорю браузер
    // сам прокручивает страницу к форме, и из-под окна видно её низ. Метку
    // чистим, иначе окно всплывало бы при каждой перезагрузке.
    const url = new URL(location.href);
    if (url.searchParams.has('contact_posted') || url.hash) {
      url.searchParams.delete('contact_posted');
      history.replaceState(null, '', `${url.pathname}${url.search}`);
    }

    const close = () => {
      modal.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      отпуститьПрокрутку();
    };
    const onKey = (event) => {
      if (event.key === 'Escape') close();
    };

    document.addEventListener('keydown', onKey);
    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('[data-fz-modal-close]')) close();
    });

    // Страницу ставим на форму, а не на то место, куда её увёл якорь, и только
    // потом запираем прокрутку: так после закрытия окна человек видит форму,
    // а не хвост страницы.
    document.querySelector('.fz-callback, [data-fz-callback], #contact_form')?.scrollIntoView({ block: 'center' });
    заперетьПрокрутку();

    // Кадр задержки: без него не отрабатывает переход, элемент уже видим.
    // Фокус ставим там же: скрытому элементу его не отдать.
    requestAnimationFrame(() => {
      modal.classList.add('is-open');
      $('[data-fz-modal-close]', modal)?.focus();
    });
  }

  /* ── Окно поиска ─────────────────────────────────────────
     Открывается лупой в шапке. Фокус уводим в поле и возвращаем на кнопку
     при закрытии: иначе с клавиатуры после Esc непонятно, где ты находишься. */
  function initSearch() {
    const overlay = $('[data-fz-search]');
    if (!overlay || overlay.dataset.wired) return;
    overlay.dataset.wired = 'true';

    let opener = null;

    const close = () => {
      overlay.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      отпуститьПрокрутку();
      if (opener) opener.focus();
    };
    const onKey = (event) => {
      if (event.key === 'Escape') close();
    };

    const open = (button) => {
      opener = button;
      overlay.classList.add('is-open');
      заперетьПрокрутку();
      document.addEventListener('keydown', onKey);
      requestAnimationFrame(() => $('[data-fz-search-input]', overlay)?.focus());
    };

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay || event.target.closest('[data-fz-search-close]')) close();
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-fz-search-open]');
      if (!trigger) return;
      event.preventDefault();
      open(trigger);
    });
  }

  /* ── Счётчик количества ────────────────────────────────
     Остался на случай, если счётчик понадобится в форме заявки. */
  function stepQty(button) {
    const wrap = button.closest('.fz-qty');
    const input = $('[data-fz-qty-input]', wrap);
    if (!input) return;
    const min = Number(input.min || 1);
    const next = Math.max(min, (Number(input.value) || min) + Number(button.dataset.fzQty));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ── Выбор варианта ──────────────────────────────────── */
  function initVariants() {
    const form = $('[data-fz-product-form]');
    const dataEl = $('[data-fz-variants]');
    if (!form || !dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

    const selects = $$('[data-fz-option]', form);
    if (!selects.length) return;

    const money = (cents) => {
      const shopFormat = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      const value = (cents / 100).toLocaleString('ru-RU', { maximumFractionDigits: 0 });
      return shopFormat ? `${value} ${shopFormat === 'KZT' ? '₸' : shopFormat}` : value;
    };

    const sync = () => {
      const chosen = selects.map((s) => s.value);
      const match = variants.find((v) => chosen.every((val, i) => v[`option${i + 1}`] === val));

      const idField = $('[data-fz-variant-id]', form);
      const priceEl = $('[data-fz-price]');
      const compareEl = $('[data-fz-compare]');

      if (!match) return;

      if (idField) idField.value = match.id;
      if (priceEl && match.price != null) priceEl.textContent = money(match.price);
      if (compareEl) {
        const show = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.hidden = !show;
        if (show) compareEl.textContent = money(match.compare_at_price);
      }
    };

    selects.forEach((s) => s.addEventListener('change', sync));
    sync();
  }

  /* ── Калькулятор запаса хода ─────────────────────────────
     Оставлен на случай, если понадобится вернуть: на карточке товара его место
     занимает форма заявки. Разметки с [data-fz-range] сейчас нет ни на одной
     странице, и функция тихо выходит. */
  function initRange() {
    const box = $('[data-fz-range]');
    if (!box) return;
    const input = $('[data-fz-consumption]', box);
    const out = $('[data-fz-range-out]', box);
    const capacity = Number(box.dataset.capacity);
    if (!input || !out || !capacity) return;

    const recalc = () => {
      const consumption = parseFloat(String(input.value).replace(',', '.'));
      if (!consumption || consumption <= 0) {
        out.textContent = '—';
        return;
      }
      const km = Math.round((capacity / consumption) * 100);
      out.textContent = `${km.toLocaleString('ru-RU')} км`;
    };

    input.addEventListener('input', recalc);
    recalc();
  }

  /* ── Галерея товара ───────────────────────────────────
     Лента листается силами браузера: scroll-snap даёт и прилипание, и инерцию
     на телефоне, и работает, даже если скрипт не загрузился. Здесь только
     подсветка миниатюры, счётчик и стрелки. */
  let gallery = null;

  function initGallery() {
    const root = $('[data-fz-gallery]');
    const track = root && $('[data-fz-gallery-track]', root);
    if (!track) {
      gallery = null;
      return;
    }

    const slides = $$('[data-fz-slide]', track);
    const thumbs = $$('[data-fz-thumb]');
    const counter = $('[data-fz-gallery-counter]', root);
    const navs = $$('[data-fz-gallery-nav]', root);
    let index = 0;

    const show = (i) => {
      index = Math.min(slides.length - 1, Math.max(0, i));
      thumbs.forEach((t) => t.classList.toggle('is-active', Number(t.dataset.index) === index));
      // На телефоне миниатюры лежат лентой в один ряд, и активная может уехать
      // за край. Подкручиваем ленту к ней, страницу не трогаем: scrollIntoView
      // потянул бы и вертикальную прокрутку.
      const лента = thumbs[0]?.parentElement;
      const активная = thumbs[index];
      if (лента && активная && лента.scrollWidth > лента.clientWidth + 1) {
        const сдвиг = активная.getBoundingClientRect().left - лента.getBoundingClientRect().left;
        лента.scrollTo({
          left: лента.scrollLeft + сдвиг - лента.clientWidth / 2 + активная.offsetWidth / 2,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }
      if (counter) counter.innerHTML = `${index + 1}&nbsp;/&nbsp;${slides.length}`;
      navs.forEach((n) => {
        const шаг = Number(n.dataset.fzGalleryNav);
        n.disabled = шаг < 0 ? index === 0 : index === slides.length - 1;
      });
    };

    const goTo = (i) => {
      const цель = Math.min(slides.length - 1, Math.max(0, i));
      track.scrollTo({ left: track.clientWidth * цель, behavior: reduceMotion ? 'auto' : 'smooth' });
      show(цель);
    };

    // Прокрутку читаем в кадре отрисовки: событие сыплется десятками в секунду.
    let ждём = 0;
    track.addEventListener(
      'scroll',
      () => {
        if (ждём) return;
        ждём = requestAnimationFrame(() => {
          ждём = 0;
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index) show(i);
        });
      },
      { passive: true },
    );

    show(0);
    gallery = { slides, goTo, current: () => index };
  }

  /* ── Просмотрщик кадров ───────────────────────────────
     Жесты считаем сами: браузеру нельзя отдать ни прокрутку, ни своё
     увеличение, иначе один палец потянет страницу, а два зумируют её вместе
     с интерфейсом. Поэтому у сцены `touch-action: none`, а сюда легли
     перелистывание пальцем, щипок двумя и перетаскивание увеличенного кадра. */
  function openLightbox(slides, start) {
    const dlg = document.createElement('dialog');
    dlg.className = 'fz-lightbox';
    dlg.innerHTML = `
      <div class="fz-lightbox__stage" data-stage>
        <div class="fz-lightbox__track" data-track></div>
      </div>
      <button type="button" class="fz-lightbox__btn fz-lightbox__close" data-close aria-label="Закрыть">×</button>
      <button type="button" class="fz-lightbox__btn fz-lightbox__prev" data-nav="-1" aria-label="Предыдущий кадр">‹</button>
      <button type="button" class="fz-lightbox__btn fz-lightbox__next" data-nav="1" aria-label="Следующий кадр">›</button>
      <p class="fz-lightbox__counter" data-counter></p>
    `;

    const stage = $('[data-stage]', dlg);
    const track = $('[data-track]', dlg);
    const counter = $('[data-counter]', dlg);

    const imgs = slides.map((s) => {
      const box = document.createElement('div');
      box.className = 'fz-lightbox__slide';
      const img = document.createElement('img');
      img.alt = ($('img', s) || {}).alt || '';
      img.decoding = 'async';
      box.append(img);
      track.append(box);
      return img;
    });

    let i = Math.min(imgs.length - 1, Math.max(0, start));
    let scale = 1;
    let tx = 0;
    let ty = 0;
    let dragX = 0;
    const pointers = new Map();
    let pinch = null;
    let drag = null;
    let lastTap = 0;

    // Грузим только соседние кадры: у Jeep их шестнадцать по 2048 px.
    const preload = () => {
      for (let n = i - 1; n <= i + 1; n++) {
        const img = imgs[n];
        if (img && !img.src) img.src = slides[n].dataset.full;
      }
    };

    const центрСцены = () => {
      const r = stage.getBoundingClientRect();
      return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    };

    const applyTrack = (плавно) => {
      track.style.transition = плавно && !reduceMotion ? 'transform .25s ease-out' : 'none';
      track.style.transform = `translateX(${-i * stage.clientWidth + dragX}px)`;
    };

    const applyZoom = (плавно) => {
      const img = imgs[i];
      img.style.transition = плавно && !reduceMotion ? 'transform .2s ease-out' : 'none';
      img.style.transform = `translate(${tx}px, ${ty}px) scale(${scale})`;
    };

    /**
     * Увеличенный кадр не должен уезжать краем внутрь сцены.
     *
     * Считаем по нарисованному кадру, а не по его блоку: при `object-fit:
     * contain` блок шире картинки, и по нему кадр можно было бы утащить
     * в пустое поле сбоку.
     */
    const clampPan = () => {
      const img = imgs[i];
      const k = img.naturalWidth
        ? Math.min(img.clientWidth / img.naturalWidth, img.clientHeight / img.naturalHeight)
        : 1;
      const w = (img.naturalWidth ? img.naturalWidth * k : img.clientWidth) * scale;
      const h = (img.naturalHeight ? img.naturalHeight * k : img.clientHeight) * scale;
      const mx = Math.max(0, (w - stage.clientWidth) / 2);
      const my = Math.max(0, (h - stage.clientHeight) / 2);
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    };

    const resetZoom = () => {
      const img = imgs[i];
      img.style.transition = 'none';
      img.style.transform = '';
      scale = 1;
      tx = 0;
      ty = 0;
    };

    const go = (шаг, плавно = true) => {
      const цель = Math.min(imgs.length - 1, Math.max(0, i + шаг));
      if (цель !== i) resetZoom();
      i = цель;
      dragX = 0;
      applyTrack(плавно);
      preload();
      counter.innerHTML = `${i + 1}&nbsp;/&nbsp;${imgs.length}`;
      $('[data-nav="-1"]', dlg).disabled = i === 0;
      $('[data-nav="1"]', dlg).disabled = i === imgs.length - 1;
    };

    /** Увеличение вокруг точки: то, что под пальцами, остаётся на месте. */
    const zoomAt = (k, sx, sy) => {
      const c = центрСцены();
      const прежний = scale;
      const u = { x: (sx - c.x - tx) / прежний, y: (sy - c.y - ty) / прежний };
      scale = Math.min(5, Math.max(1, k));
      tx = sx - c.x - u.x * scale;
      ty = sy - c.y - u.y * scale;
      if (scale === 1) {
        tx = 0;
        ty = 0;
      } else {
        clampPan();
      }
    };

    const расстояние = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);
    const середина = (a, b) => ({ x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 });

    stage.addEventListener('pointerdown', (e) => {
      // Захват пальца нужен, чтобы жест не терялся при выходе за край кадра.
      // Бросает на неактивном указателе — в том числе на синтетическом
      // событии из проверки витрины, поэтому падать тут нельзя.
      try {
        stage.setPointerCapture(e.pointerId);
      } catch {
        /* не беда */
      }
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        const [a, b] = [...pointers.values()];
        pinch = { d0: расстояние(a, b), s0: scale, mid0: середина(a, b), t0: { x: tx, y: ty } };
        drag = null;
      } else if (pointers.size === 1) {
        drag = { x0: e.clientX, y0: e.clientY, tx0: tx, ty0: ty, moved: false };
      }
    });

    stage.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pinch && pointers.size >= 2) {
        const [a, b] = [...pointers.values()];
        const c = центрСцены();
        const u = { x: (pinch.mid0.x - c.x - pinch.t0.x) / pinch.s0, y: (pinch.mid0.y - c.y - pinch.t0.y) / pinch.s0 };
        scale = Math.min(5, Math.max(1, (pinch.s0 * расстояние(a, b)) / pinch.d0));
        const m = середина(a, b);
        tx = m.x - c.x - u.x * scale;
        ty = m.y - c.y - u.y * scale;
        clampPan();
        applyZoom(false);
        return;
      }

      if (!drag || pointers.size !== 1) return;
      const dx = e.clientX - drag.x0;
      const dy = e.clientY - drag.y0;
      if (Math.abs(dx) > 4 || Math.abs(dy) > 4) drag.moved = true;

      if (scale > 1) {
        tx = drag.tx0 + dx;
        ty = drag.ty0 + dy;
        clampPan();
        applyZoom(false);
      } else {
        dragX = dx;
        applyTrack(false);
      }
    });

    const отпустили = (e) => {
      pointers.delete(e.pointerId);

      if (pinch && pointers.size < 2) {
        pinch = null;
        if (scale <= 1.05) {
          scale = 1;
          tx = 0;
          ty = 0;
          applyZoom(true);
        }
        // Оставшийся палец продолжает как перетаскивание, а не как новый жест.
        const [остался] = [...pointers.values()];
        if (остался) drag = { x0: остался.x, y0: остался.y, tx0: tx, ty0: ty, moved: true };
        return;
      }

      if (pointers.size || !drag) return;

      if (scale === 1) {
        const порог = stage.clientWidth * 0.18;
        if (dragX < -порог) go(1);
        else if (dragX > порог) go(-1);
        else {
          dragX = 0;
          applyTrack(true);
        }
      }

      if (!drag.moved) {
        const поКадру = e.target.tagName === 'IMG';
        const теперь = Date.now();
        if (поКадру && теперь - lastTap < 300) {
          lastTap = 0;
          zoomAt(scale > 1 ? 1 : 2.5, e.clientX, e.clientY);
          applyZoom(true);
        } else {
          lastTap = теперь;
          // Щелчок мимо кадра закрывает — привычно и не мешает щипку.
          if (!поКадру && scale === 1) dlg.close();
        }
      }
      drag = null;
    };

    stage.addEventListener('pointerup', отпустили);
    stage.addEventListener('pointercancel', отпустили);

    stage.addEventListener(
      'wheel',
      (e) => {
        e.preventDefault();
        zoomAt(scale * (e.deltaY < 0 ? 1.15 : 1 / 1.15), e.clientX, e.clientY);
        applyZoom(false);
      },
      { passive: false },
    );

    dlg.addEventListener('click', (e) => {
      if (e.target.closest('[data-close]')) dlg.close();
      const nav = e.target.closest('[data-nav]');
      if (nav) go(Number(nav.dataset.nav));
    });

    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') go(1);
      if (e.key === 'ArrowLeft') go(-1);
    });

    const перерисовать = () => {
      resetZoom();
      applyTrack(false);
    };
    addEventListener('resize', перерисовать);

    dlg.addEventListener('close', () => {
      removeEventListener('resize', перерисовать);
      document.body.style.overflow = '';
      dlg.remove();
    });

    document.body.append(dlg);
    document.body.style.overflow = 'hidden';
    dlg.showModal();
    preload();

    // Первый кадр ставим без перехода. Иначе при открытии не с первого кадра
    // лента едет к нужному через все предыдущие: смещение считается от ширины
    // сцены, а до showModal она нулевая, и лента успевает встать в ноль.
    go(0, false);
    // Ширина могла быть ещё не посчитана в тот же тик — повторяем в следующем
    // кадре, снова без перехода, поэтому проезда не видно в любом случае.
    requestAnimationFrame(() => applyTrack(false));
  }

  /* ── Мобильное меню ──────────────────────────────────────
     Выдвижная панель поверх страницы, устроена как окно поиска: та же
     блокировка прокрутки, Esc, щелчок по фону, возврат фокуса на бургер.
     Раньше меню раскрывалось блоком под шапкой и сдвигало страницу вниз. */
  function initNav() {
    const drawer = $('[data-fz-nav]');
    if (!drawer || drawer.dataset.wired) return;
    drawer.dataset.wired = 'true';

    let opener = null;
    const открыто = () => drawer.classList.contains('is-open');

    const close = () => {
      if (!открыто()) return;
      drawer.classList.remove('is-open');
      $$('[data-fz-burger]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
      document.removeEventListener('keydown', onKey);
      отпуститьПрокрутку();
      if (opener) opener.focus({ preventScroll: true });
    };
    const onKey = (event) => {
      if (event.key === 'Escape') close();
    };
    const open = (button) => {
      opener = button;
      drawer.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      заперетьПрокрутку();
      document.addEventListener('keydown', onKey);
      requestAnimationFrame(() => $('[data-fz-nav-close]', drawer)?.focus({ preventScroll: true }));
    };

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer || event.target.closest('[data-fz-nav-close]')) {
        close();
        return;
      }
      // Якорная ссылка на ту же страницу перехода не делает, панель закрываем сами.
      if (event.target.closest('a')) close();
    });

    document.addEventListener('click', (event) => {
      const burger = event.target.closest('[data-fz-burger]');
      if (!burger) return;
      event.preventDefault();
      if (открыто()) close();
      else open(burger);
    });

    // Экран стал широким: панели там нет, а прокрутку надо вернуть.
    matchMedia('(min-width: 861px)').addEventListener('change', (m) => {
      if (m.matches) close();
    });
  }

  /* ── Фильтр каталога ──────────────────────────────────
     Скрипта у фильтра нет намеренно. Он собран ссылками, фильтрует Shopify
     по тегам через адрес, поэтому работает без JavaScript, дружит с постраничным
     выводом и переживает «назад». Здесь остаётся только закрывать соседнюю
     выпадашку: у <details name> это делает браузер, но не везде. */
  function initFilter() {
    const фильтр = $('.fz-filter');
    if (!фильтр || фильтр.dataset.wired) return;
    фильтр.dataset.wired = 'true';
    // На узком экране ряд листается вбок, и выбранная метка может оказаться
    // за краем: тогда непонятно, что вообще выбрано. Подкручиваем к ней.
    for (const ряд of $$('.fz-chips', фильтр)) {
      const выбрана = $('.fz-chip.is-active', ряд);
      if (выбрана && ряд.scrollWidth > ряд.clientWidth) {
        ряд.scrollLeft = выбрана.offsetLeft - ряд.clientWidth / 2 + выбрана.offsetWidth / 2;
      }
    }
  }

  /* ── Делегирование ───────────────────────────────────── */
  document.addEventListener('click', (event) => {
    const video = event.target.closest('[data-fz-video]:not(.is-playing)');
    if (video) {
      event.preventDefault();
      openVideo(video);
      return;
    }

    // Кнопка «Напишите нам» ведёт к форме на этой же странице.
    const jump = event.target.closest('[data-fz-scroll]');
    if (jump) {
      const target = document.querySelector(jump.getAttribute('href'));
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        const field = $('input, textarea', target);
        if (field) field.focus({ preventScroll: true });
      }
      return;
    }

    const qty = event.target.closest('[data-fz-qty]');
    if (qty) {
      event.preventDefault();
      stepQty(qty);
      return;
    }

    const gnav = event.target.closest('[data-fz-gallery-nav]');
    if (gnav) {
      event.preventDefault();
      if (gallery) gallery.goTo(gallery.current() + Number(gnav.dataset.fzGalleryNav));
      return;
    }

    const slide = event.target.closest('[data-fz-slide]');
    if (slide && gallery) {
      event.preventDefault();
      if (slide.dataset.youtube) {
        // Ролик играем прямо в ленте: в просмотрщике ему делать нечего.
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube-nocookie.com/embed/${slide.dataset.youtube}?autoplay=1&rel=0`;
        frame.allow = 'autoplay; encrypted-media; picture-in-picture';
        frame.allowFullscreen = true;
        frame.title = 'Видео';
        frame.style.cssText = 'width:100%;height:100%;border:0';
        slide.replaceChildren(frame);
      } else {
        openLightbox(gallery.slides, Number(slide.dataset.index));
      }
      return;
    }

    const thumb = event.target.closest('[data-fz-thumb]');
    if (thumb) {
      event.preventDefault();
      if (gallery) gallery.goTo(Number(thumb.dataset.index));
      return;
    }

  });

  function init() {
    initHeroVideo();
    initModal();
    initSearch();
    initNav();
    initVariants();
    initRange();
    initFilter();
    initGallery();
    initPhone();
    initCallbackEmail();
    initGoals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Редактор темы перерисовывает секции — переинициализируем то, что живёт на узлах.
  document.addEventListener('shopify:section:load', init);
})();
